import SignupForm from '../Components/Forms/SignupForm'

const Signup = () => {
  return (
    <div className="signup">
      <SignupForm />
    </div>
  )
}

export default Signup
